import { UnitOfMeasureEnum } from '@enums/recipe-enums';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { GroupProps } from '@repo/ui/src/types';
import ShoppableIngredient from '@views/RecipeDetailPage/ShoppableIngredient';

interface Props {
  group: GroupProps;
  unitOfMeasure: number;
}

const IngredientList = ({ group, unitOfMeasure }: Props) => {
  return (
    <div key={group.groupKey} className="tw-mt-3">
      <h6 className="tra-text-web-heading-6 tw-text-left tw-mb-0">{group.groupName}</h6>
      <table className="tw-border-separate tw-border-spacing-y-4">
        <tbody>
          {group.ingredients.map((ingredient, i) => {
            return (
              <tr key={`ingredient_${i}`}>
                <td className="tra-text-web-body-s tw-mb-0 tw-pr-2 tw-border-r tw-text-nowrap">
                  {unitOfMeasure === UnitOfMeasureEnum.Imperial ? (
                    <>
                      {ingredient?.imperial?.measurementDisplay} {ingredient?.unitOfMeasure}
                    </>
                  ) : (
                    <>
                      {ingredient?.metric?.measurementDisplay} {ingredient?.metric?.unitOfMeasure}
                    </>
                  )}
                </td>
                {ingredient?.ingredient?.product ? (
                  <ShoppableIngredient product={ingredient.ingredient.product} />
                ) : (
                  <td itemProp="recipeIngredient" className="tra-text-web-body-l tw-mb-0 tw-pl-2">
                    {ingredient?.ingredient?.link?.link ? (
                      <Anchor
                        className="tw-text-brand-300 tw-underline hover:tw-underline"
                        link={ingredient.ingredient.link.link}
                      >
                        {ingredient?.ingredient?.name}
                      </Anchor>
                    ) : (
                      ingredient?.ingredient?.name
                    )}
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default IngredientList;
